var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import TreeItem from './TreeItem';
import { UIComponent, childrenExist, commonPropTypes, } from '../../lib';
import { defaultBehavior } from '../../lib/accessibility';
import * as customPropTypes from '../../lib/customPropTypes';
/**
 * Allows users to display data organised in tree-hierarchy.
 */
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tree.prototype.renderContent = function () {
        var _a = this.props, items = _a.items, renderItemTitle = _a.renderItemTitle;
        return _.map(items, function (item) {
            return TreeItem.create(item, {
                defaultProps: {
                    renderItemTitle: renderItemTitle,
                },
            });
        });
    };
    Tree.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest, styles = _a.styles, variables = _a.variables;
        var children = this.props.children;
        return (React.createElement(ElementType, __assign({ className: classes.root }, accessibility.attributes.root, rest), childrenExist(children) ? children : this.renderContent()));
    };
    Tree.className = 'ui-tree';
    Tree.displayName = 'Tree';
    Tree.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.func, items: customPropTypes.collectionShorthand, renderItemTitle: PropTypes.func });
    Tree.defaultProps = {
        as: 'ul',
        accessibility: defaultBehavior,
    };
    return Tree;
}(UIComponent));
export default Tree;
